// Strip out all non-essential separator characters and normalize to lower case
export function cleanMacAddress(macAddress: string): string {
    return macAddress && macAddress.toLowerCase().replace(/[^0-9a-f]/g, '');
}

// Put the separators back in (for consumption by the Gateway)
export function expandMacAddress(macAddress: string): string {
    const a = cleanMacAddress(macAddress);
    return a && `${a[0]}${a[1]}:${a[2]}${a[3]}:${a[4]}${a[5]}:${a[6]}${a[7]}:${a[8]}${a[9]}:${a[10]}${a[11]}`;
}
